const Colors = [
    [
        "#0a0a0a",
        "#dddddd",
        "#FABF01",
    ],
    [
        "#0a0a0a",
        "#dddddd",
        "#efcc7c",
    ],
    [
        "#0a0a0a",
        "#dddddd",
    ],
    [
        "#0a0a0a",
        "#dddddd",
    ],
    [
        "#0a0a0a",
        "#dddddd",
    ],
    [
        "#DBDDDC",
        "#fff",
        "#0a0a0a",
        "#0a0a0a",
    ],
    [
        "#0a0a0a",
        "#efcc7c",
        "#dddddd",
        "#dddddd",
        "#dddddd",
        "#dddddd",
    ],
    // 1

    [
        "#221816",
        "#FABF01",
        "#125FAF",
        "#01886A",
        "#6B5B99",
        "#E90013",
        "#FAEAD1",
    ],
    [
        "#221816",
        "#FABF01",
        "#125FAF",
        "#01886A",
        "#6B5B99",
        "#E90013",
        "#FAEAD1",
    ],
    [
        "#221816",
        "#FABF01",
        "#125FAF",
        "#01886A",
        "#6B5B99",
        "#E90013",
        "#FAEAD1",
    ],
    [
        "#020202",
        "#00BB70",
        "#0075CA",
        "#FDDC3F",
        "#FF6936",
    ],
    
    [
        "#2A1F1D",
        "#F0E0C6",
        "#DF4A33",
        "#FBAF3C",
        "#7A999C",
        "#475B62",
    ],
    [
        "#022D8F",
        "#f9cd22",
        "MediumSeaGreen",
        "#e94e19",
        "#cc0028",
    ],
    [
        "#000000",
        "#f1594a",
        "#14a160",
        "#acc1bc",
        "#d38e1a",
    ],
    [
        "#0a0a0a",
        "#FFFCC9",
        "#ED555D",
        "#41B797",
        "#EDA126",
        "#7B5770",
    ],
    [
        "#544E47",
        "#CFC7B9",
        "#D1AF84",
        "#CEC8B8",
        "#F3B551",
        "#E15147",
        "#4AAD8B",
    ],
    [
        "#2619d1",
        "#ffffff",
        "#f0292f",
        "#fb6119",
        "#3e8741",
    ],
    [
        "#2619d1",
        "#ffffff",
        "#2969ee",
        "#efcc7c",
    ],
    [
        "#000000",
        "#f1594a",
        "#2969de",
        "#14a160",
    ],
    // 2

    [
        "#221816",
        "#FABF01",
        "#125FAF",
        "#01886A",
        "#6B5B99",
        "#E90013",
        "#FAEAD1",
    ],
    [
        "#221816",
        "#FABF01",
        "#125FAF",
        "#01886A",
        "#6B5B99",
        "#E90013",
        "#FAEAD1",
    ],
    [
        "#221816",
        "#FABF01",
        "#125FAF",
        "#01886A",
        "#6B5B99",
        "#E90013",
        "#FAEAD1",
    ],
    [
        "#020202",
        "#00BB70",
        "#0075CA",
        "#FDDC3F",
        "#FF6936",
    ],
    
    [
        "#2A1F1D",
        "#F0E0C6",
        "#DF4A33",
        "#FBAF3C",
        "#7A999C",
        "#475B62",
    ],
    [
        "#022D8F",
        "#f9cd22",
        "MediumSeaGreen",
        "#e94e19",
        "#cc0028",
    ],
    [
        "#000000",
        "#f1594a",
        "#14a160",
        "#acc1bc",
        "#d38e1a",
    ],
    [
        "#0a0a0a",
        "#FFFCC9",
        "#ED555D",
        "#41B797",
        "#EDA126",
        "#7B5770",
    ],
    [
        "#544E47",
        "#CFC7B9",
        "#D1AF84",
        "#CEC8B8",
        "#F3B551",
        "#E15147",
        "#4AAD8B",
    ],
    [
        "#2619d1",
        "#ffffff",
        "#f0292f",
        "#fb6119",
        "#3e8741",
    ],
    [
        "#2619d1",
        "#ffffff",
        "#2969ee",
        "#efcc7c",
    ],
    [
        "#000000",
        "#f1594a",
        "#2969de",
        "#14a160",
    ],
]
export default Colors